import find from 'lodash/find'
import type { MetadataSchema } from './MetadataSchema'

/**
 * View-mode label resolver for a row's Value cell.
 *
 * Most cells store and display the same string (numbers, plain text — Value `"4"` displays as
 * `"4"`). But when the schema's `input` is `MetadataValueSelect`, the underlying value is a
 * dropdown option's `value` (e.g. `"ACS"`) while the user-facing label is the option's `label`
 * (e.g. `"Accessories"`). The raw code in view mode is unreadable, so look it up against the
 * schema's `inputProps.options` and render the label.
 *
 * Falls back to `String(value)` when there's no schema, no options, or no matching option — so
 * non-Select fields and unknown values still render something.
 */
export const resolveValueDisplay = (value: unknown, schema?: MetadataSchema): string => {
  if (value == null) return ''
  const options = schema?.inputProps?.options
  if (Array.isArray(options)) {
    const found = find(options, (o) => o?.value === value)
    if (found?.label != null) return String(found.label)
  }
  return String(value)
}
